import { useQuery } from "@tanstack/react-query";
import { reportService } from "@/services/reportService";
import { ReportFilter } from "@/types";
import { useState } from "react";

export const useReports = (initialPage: number = 1, initialLimit: number = 10) => {
    const [page, setPage] = useState(initialPage);
    const [limit, setLimit] = useState(initialLimit);
    const [filters, setFilters] = useState<ReportFilter>({});

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["reports", page, limit, filters],
        queryFn: () => reportService.getReports(page, limit, filters),
    });

    return {
        reports: data?.data ?? [],
        total: data?.total ?? 0,
        loading: isLoading,
        error: error ? (error instanceof Error ? error.message : "Failed to fetch reports") : null,
        page,
        limit,
        filters,
        setPage,
        setLimit,
        setFilters,
        refresh: refetch,
    };
};
